import { dataBooksBookmarkSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBooksBookmarkSolid = /*#__PURE__*/createIcon(dataBooksBookmarkSolid)
export default IconBooksBookmarkSolid
